// components/MetricsOverviewSkeleton.tsx
import React from 'react';
import { Grid, Card, CardContent, Box, Skeleton } from '@mui/material';

export const MetricsOverviewSkeleton: React.FC = () => {
  // Create 3 skeleton cards to match the metrics layout
  const skeletonCards = [1, 2];

  return (
    <Grid container spacing={3}>
      {skeletonCards.map((_, index) => (
        <Grid item width={'50%'} key={index}>
          <Card className="metricCard">
            <CardContent>
              {/* Header Section */}
              <Box className="metricCardHeader">
                <div className="d-flex align-center">
                  {/* Icon Skeleton */}
                  <Skeleton
                    variant="rounded"
                    width={48}
                    height={48}
                    sx={{ borderRadius: '12px' }}
                  />
                  {/* Value Skeleton */}
                  <div className="ml-10">
                    <Skeleton
                      variant="text"
                      width={60}
                      height={32}
                      sx={{ fontSize: '1.5rem' }}
                    />
                  </div>
                </div>
                {/* Change Badge Skeleton */}
                <Box className="changeBadge">
                  <Skeleton
                    variant="rounded"
                    width={80}
                    height={32}
                    sx={{ borderRadius: '9999px' }}
                  />
                </Box>
              </Box>

              {/* Title Section */}
              <Box className="metricMainInfo">
                <Skeleton
                  variant="text"
                  width="60%"
                  height={24}
                  sx={{ marginBottom: '20px' }}
                />
              </Box>

              {/* Sub Metrics Section */}
              <Box className="subMetricsContainer">
                {/* First Sub Metric */}
                <Box className="subMetricRow">
                  <Box className="subMetricLabel">
                    <Skeleton
                      variant="circular"
                      width={16}
                      height={16}
                      sx={{ marginRight: '8px' }}
                    />
                    <Skeleton variant="text" width={80} height={20} />
                  </Box>
                  <Box className="subMetricValues">
                    <Skeleton variant="text" width={60} height={20} />
                  </Box>
                </Box>

                {/* Second Sub Metric */}
                <Box className="subMetricRow">
                  <Box className="subMetricLabel">
                    <Skeleton
                      variant="circular"
                      width={16}
                      height={16}
                      sx={{ marginRight: '8px' }}
                    />
                    <Skeleton variant="text" width={80} height={20} />
                  </Box>
                  <Box className="subMetricValues">
                    <Skeleton variant="text" width={60} height={20} />
                  </Box>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
